import i18nFactory from '@yandex-int/i18n';
import moment from 'moment';
import { PushAction } from 'redux-little-router';
import { combineEpics, Epic, ofType } from 'redux-observable';
import { EMPTY, from, Observable, of } from 'rxjs';
import { mergeMap, switchMap } from 'rxjs/operators';
import { Error } from 'tslint/lib/error';

import { Action } from '../../../actions';
import {
    changeLocation,
    DummyAction,
    dummyAction,
    replaceLocation
} from '../../../actions/common';
import { openCommonPriceEditor } from '../../../actions/commonPriceEditor';
import {
    toggleFeedFilterPriorityModal,
    toggleFeedFilterRateModal
} from '../../../actions/feed-filters/grid';
import {
    getNoticeParamsForMassAction,
    getNoticeParamsForMassActionMessage,
    getNoticeTypeForCopyMassAction,
    GO_TO_BANNERS_EDIT_FOR_CREATION,
    GO_TO_GROUPS_EDIT_FOR_CREATION,
    GO_TO_INTERNAL_BANNERS_EDIT_FOR_CREATION,
    goToBannersEdit,
    GoToBannersEditForCreationAction,
    goToBannersMassEdit,
    goToCampaignModerationOffer,
    goToDirectPaymentInstructions,
    goToGroupsEdit,
    GoToGroupsEditForCreationAction,
    goToInternalBannersEdit,
    GoToInternalBannersEditAction,
    GoToInternalBannersEditForCreationAction,
    goToInternalBannersMassEdit,
    goToLogs,
    goToStatistics,
    GRID_SCREEN_CANCEL_CELL_EDIT,
    GRID_SCREEN_GO_TO_BANNERS_EDIT,
    GRID_SCREEN_GO_TO_BANNERS_MASS_EDIT,
    GRID_SCREEN_GO_TO_CAMPAIGN_MODERATION_OFFER,
    GRID_SCREEN_GO_TO_CAMPAIGNS_EDIT,
    GRID_SCREEN_GO_TO_DIRECT_PAYMENT_INSTRUCTIONS,
    GRID_SCREEN_GO_TO_GROUPS_EDIT,
    GRID_SCREEN_GO_TO_INTERNAL_BANNERS_EDIT,
    GRID_SCREEN_GO_TO_INTERNAL_BANNERS_MASS_EDIT,
    GRID_SCREEN_GO_TO_LOGS,
    GRID_SCREEN_GO_TO_STATISTICS,
    GRID_SCREEN_HANDLE_BULK_ITEMS,
    GRID_SCREEN_HANDLE_COLUMNS_ORDER_CHANGE,
    GRID_SCREEN_HANDLE_COLUMNS_VISIBILITY_CHANGE,
    GRID_SCREEN_HANDLE_COLUMNS_WIDTH_UPDATE,
    GRID_SCREEN_HANDLE_ITEM_ACTION,
    GRID_SCREEN_HANDLE_NAVIGATION_LINK_CLICK,
    GridScreenCancelCellEditAction,
    gridScreenChangeColumnsOrder,
    gridScreenChangeColumnsVisibility,
    GridScreenGoToBannersEditAction,
    GridScreenGoToCampaignModerationOfferAction,
    GridScreenGoToCampaignsEditAction,
    GridScreenGoToDirectPaymentInstructions,
    GridScreenGoToGroupsEditAction,
    GridScreenGoToStatisticsAction,
    GridScreenHandleBulkItemsAction,
    GridScreenHandleColumnsOrderChangeAction,
    GridScreenHandleColumnsVisibilityChangeAction,
    GridScreenHandleColumnsWidthUpdateAction,
    GridScreenHandleItemAction,
    GridScreenHandleNavigationLinkClickAction,
    gridScreenUpdateColumnsWidth,
    NoticeType,
    openDuplicateGroupsModal,
    OpenMinusPhraseSelectorGridModal,
    openMinusPhraseSelectorGridModal,
    resetGridData,
    ResetGridData,
    showNoticeMessage,
    UpdateActionProgress,
    updateActionProgress,
    updateEditCellData,
    UpdateGridSelection,
    updateSelection
} from '../../../actions/grid-screen';
import {
    OpenPricesWizard,
    openPricesWizard
} from '../../../actions/grid-wizards';
import { switchSearchAndReplaceInspectorVisibility } from '../../../actions/phrases-grid';
import {
    fetchPhrasesForPhrasesSelectorWizard,
    openPhrasesSelectorWizard
} from '../../../actions/phrasesSelectorWizard';
import { FormRequestManager } from '../../../api/FormRequestManager';
import { mapDateRangePresetToDatePeriod } from '../../../mappers/common/common';
import { selectGridSourceParams } from '../../../selectors/gridSourceParams/gridSourceParams';
import {
    getColumnSettingsWithUpdatedOrder,
    getColumnsVisibilitySettings,
    getColumnsWidthSettings
} from '../../../service/ActionHelpers';
import { BannersIdsForBannersEditHelpers } from '../../../service/BannersIdsForBannersEditHelpers';
import { CampaignsIdsForCampaignsEditHelpers } from '../../../service/CampaignsIdsForCampaignsEditHelpers';
import { confirm } from '../../../service/Confirm/Confirm';
import { confirmPayAction } from '../../../service/ConfirmPayAction/ConfirmPayAction';
import {
    ApiMethodExecutingError,
    NotSyncedError
} from '../../../service/Errors';
import { getEditCellData } from '../../../service/GridHelpers/GridHelpers';
import {
    getBannersMassActionsResultMessage,
    getCampaignsMassActionsResultMessage,
    getGridActionErrorMessage,
    getGroupItemActionsResultMessage,
    getGroupsMassActionsResultMessage,
    getPhrasesMassActionsResultMessage,
    getTextForItemActionConfirm,
    getTextForRowItemActionConfirm,
    showRetargetingActionNoticeMessage
} from '../../../service/gridItemsActionsHelpers/gridItemsActionsHelpers';
import { GroupIdsForGroupsEditHelpers } from '../../../service/GroupIdsForGroupsEditHelpers';
import { GroupsHelpers } from '../../../service/GroupsHelpers/GroupsHelpers';
import { fireGridActionParams } from '../../../service/Metrika/metrika';
import { getRequestResultNoticeParams } from '../../../service/NoticeTypeHelper/NoticeTypeHelper';
import { LocalStorage, StorageKeyType } from '../../../service/Storage/Storage';
import { EpicDeps } from '../../../service/StoreFactory';
import { UrlHelpers } from '../../../service/UrlHelpers';
import { BannersScreenUrlSearchQueryParams } from '../../../typings/banners';
import { CampaignsScreenUrlSearchQueryParams } from '../../../typings/campaigns';
import {
    banners,
    campaigns,
    feedFilters,
    groups,
    phrases,
    retargetings
} from '../../../typings/common';
import { Group, GroupBaseInfo } from '../../../typings/domain';
import {
    GdCampaignType,
    RemoderateAdsCallouts
} from '../../../typings/graphql-grid';
import {
    BannersAction,
    CampaignsAction,
    FeedFiltersAction,
    GridSelection,
    GridSelectionInfo,
    GroupsAction,
    PayActionInfo,
    PhrasesAction,
    RetargetingsAction,
    UsersProfileAction
} from '../../../typings/grid';
import {
    GroupId,
    GroupsScreenUrlSearchQueryParams
} from '../../../typings/groups';
import { PhrasesSelectorWizardId } from '../../../typings/phrases';
import { State } from '../../../typings/state';
import {
    deleteFeedFilters,
    disableFeedFilters,
    enableFeedFilters
} from '../../feed-filters-grid';

import * as keyset from './grid-screen-helpers.i18n';

const i18n = i18nFactory(keyset);

const gridScreenCancelCellEditEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$
        .ofType(GRID_SCREEN_CANCEL_CELL_EDIT)
        .map((action: GridScreenCancelCellEditAction) => {
            const state = store$.value;
            const sourceParams = selectGridSourceParams(state);
            const { editCellsData } = store$.value.grid;

            const cellKey = {
                id: action.id,
                column: action.columnName,
                view: sourceParams.view
            };

            const { isSaving } = getEditCellData(
                editCellsData,
                action.id,
                action.columnName,
                sourceParams.view
            );

            if (!isSaving) {
                return updateEditCellData(cellKey, {
                    isSaving: false,
                    error: ''
                });
            }
            return dummyAction;
        });
};

const gridScreenGoToStatisticsEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$
        .ofType(GRID_SCREEN_GO_TO_STATISTICS)
        .map((action: GridScreenGoToStatisticsAction) => {
            const state = store$.value;
            const sourceParams = selectGridSourceParams(state);
            const { selectionInfo } = state.grid;
            let selectedInfo = action.campaignIds || [];
            let statPeriod;

            if (selectedInfo.length === 0) {
                selectedInfo = selectionInfo[sourceParams.view];
            }

            if (!sourceParams.statPeriod) {
                return dummyAction;
            }

            const selectedStatPeriod = sourceParams.statPeriod;

            if (selectedStatPeriod.statPreset) {
                const statDates = mapDateRangePresetToDatePeriod(
                    moment(),
                    selectedStatPeriod.statPreset
                );

                statPeriod = {
                    dateFrom: statDates.dateFrom.format('YYYY-MM-DD'),
                    dateTo: statDates.dateTo.format('YYYY-MM-DD')
                };
            } else if (
                selectedStatPeriod.statFrom &&
                selectedStatPeriod.statTo
            ) {
                statPeriod = {
                    dateFrom: selectedStatPeriod.statFrom,
                    dateTo: selectedStatPeriod.statTo
                };
            } else {
                return dummyAction;
            }

            const getSubmitParamsHelper = {
                clients: UrlHelpers.getCampaignsMolRequestParams,
                campaigns: UrlHelpers.getGroupsMolRequestParams
            }[sourceParams.context];

            if (getSubmitParamsHelper) {
                FormRequestManager.submit(
                    getSubmitParamsHelper(
                        selectedInfo,
                        sourceParams.login,
                        statPeriod,
                        action.target
                    )
                );
            } else {
                throw new Error(
                    `Для контекста ${
                        sourceParams.context
                    } не поддерживается переход на статистику`
                );
            }
            return dummyAction;
        });
};

const gridScreenGoToCampaignModerationOfferEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$
        .ofType(GRID_SCREEN_GO_TO_CAMPAIGN_MODERATION_OFFER)
        .map((action: GridScreenGoToCampaignModerationOfferAction) => {
            const state = store$.value;
            const { selectionInfo } = state.grid;
            const sourceParams = selectGridSourceParams(state);
            const selectedCampaigns = selectionInfo[campaigns];
            const campaign = action.campaignId || selectedCampaigns[0];

            FormRequestManager.submit(
                UrlHelpers.getCampaignModerationOfferParams(
                    campaign,
                    sourceParams.login,
                    action.target
                )
            );
            return dummyAction;
        });
};

const gridScreenGoToDirectPaymentInstructions: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$
        .ofType(GRID_SCREEN_GO_TO_DIRECT_PAYMENT_INSTRUCTIONS)
        .mergeMap(
            (
                action: GridScreenGoToDirectPaymentInstructions
            ): Observable<Action> => {
                const state = store$.value;
                const sourceParams = selectGridSourceParams(state);
                const {
                    selectionInfo: { campaigns: selectedCampaigns }
                } = store$.value.grid;

                const payObservable$ = Observable.fromPromise(
                    deps.entitiesDataProvider.fetchPayActionInfo(
                        sourceParams.login,
                        selectedCampaigns
                    )
                )
                    .mergeMap(
                        ({
                            campaignTypes,
                            unsupportedCampaigns
                        }: PayActionInfo): Observable<UpdateActionProgress> => {
                            const clickCampaignsSelected = campaignTypes.some(
                                el =>
                                    ![
                                        GdCampaignType.CPM_DEALS,
                                        GdCampaignType.CPM_BANNER
                                    ].includes(el)
                            );
                            const cpmDealsCampaginSelected = campaignTypes.includes(
                                GdCampaignType.CPM_DEALS
                            );
                            const cpmBannerCampaginsSelected = campaignTypes.includes(
                                GdCampaignType.CPM_BANNER
                            );

                            if (
                                cpmDealsCampaginSelected &&
                                (clickCampaignsSelected ||
                                    cpmBannerCampaginsSelected)
                            ) {
                                showNoticeMessage(
                                    NoticeType.error,
                                    i18n('pay-not-allowed-deals')
                                );

                                return Observable.of(
                                    updateActionProgress(false)
                                );
                            }

                            if (
                                cpmBannerCampaginsSelected &&
                                clickCampaignsSelected
                            ) {
                                showNoticeMessage(
                                    NoticeType.error,
                                    i18n('pay-not-allowed-cpm')
                                );
                                return Observable.of(
                                    updateActionProgress(false)
                                );
                            }

                            const confirmationPromise = Promise.resolve().then(
                                () => {
                                    if (unsupportedCampaigns.length === 0) {
                                        return undefined;
                                    }

                                    return confirmPayAction(
                                        unsupportedCampaigns
                                    );
                                }
                            );

                            const supportedCampaignIds = selectedCampaigns.filter(
                                (el: string) =>
                                    !unsupportedCampaigns.some(
                                        campaign => campaign.id === el
                                    )
                            );

                            return Observable.concat(
                                Observable.of(updateActionProgress(false)),
                                Observable.fromPromise(
                                    confirmationPromise
                                ).mergeMap(() => {
                                    FormRequestManager.submit(
                                        UrlHelpers.getCampaignPaymentInstructionsPage(
                                            supportedCampaignIds,
                                            sourceParams.login
                                        )
                                    );

                                    return Observable.of(
                                        updateActionProgress(false)
                                    );
                                })
                            );
                        }
                    )
                    .catch(() => Observable.of(updateActionProgress(false)));

                return Observable.concat(
                    Observable.of(updateActionProgress(true)),
                    payObservable$
                );
            }
        );
};

const gridScreenGoToBannersMassEditEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$.ofType(GRID_SCREEN_GO_TO_BANNERS_MASS_EDIT).mergeMap(
        (): Observable<DummyAction | GridScreenGoToBannersEditAction> => {
            const state = store$.value;
            const { selectionInfo } = state.grid;
            const sourceParams = selectGridSourceParams(state);

            if (sourceParams && sourceParams.login) {
                return Observable.of(
                    goToBannersEdit(
                        sourceParams.login,
                        selectionInfo[campaigns],
                        selectionInfo[banners]
                    )
                );
            } else {
                throw new Error(`Не указан логин клиента`);
            }
        }
    );
};

const gridScreenGoToBannersEditEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$.ofType(GRID_SCREEN_GO_TO_BANNERS_EDIT).mergeMap(
        ({
            login,
            campaignsIds,
            bannersIds
        }: GridScreenGoToBannersEditAction): Observable<
            DummyAction | PushAction
        > => {
            if (!campaignsIds.length || !bannersIds.length) {
                return Observable.of(dummyAction);
            }

            if (login) {
                BannersIdsForBannersEditHelpers.setCampAndBannerIds(
                    login,
                    bannersIds
                );

                return Observable.concat(
                    Observable.of(
                        changeLocation(
                            UrlHelpers.getBannersEditUrl({
                                [BannersScreenUrlSearchQueryParams.ulogin]: login,
                                [BannersScreenUrlSearchQueryParams.campaignsIds]: campaignsIds,
                                [BannersScreenUrlSearchQueryParams.bannersIds]: bannersIds
                            }),
                            undefined,
                            false
                        )
                    )
                );
            } else {
                throw new Error(`Не указан логин клиента`);
            }
        }
    );
};

const goToInternalBannersEditForCreationEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$.pipe(
        ofType(GO_TO_INTERNAL_BANNERS_EDIT_FOR_CREATION),
        mergeMap(
            (
                action: GoToInternalBannersEditForCreationAction
            ): Observable<PushAction> => {
                const { login, campaignId, groupId } = action;
                const groupsIds: Array<GroupId> = [groupId];
                const campaignsIds = [campaignId];

                BannersIdsForBannersEditHelpers.setCampAndGroupIdsForCreation(
                    login,
                    campaignsIds,
                    groupsIds
                );

                return of(
                    changeLocation(
                        UrlHelpers.getInternalBannersEditUrl({
                            [BannersScreenUrlSearchQueryParams.ulogin]: login,
                            [BannersScreenUrlSearchQueryParams.campaignsIds]: campaignsIds,
                            [BannersScreenUrlSearchQueryParams.groupsIds]: groupsIds,
                            [BannersScreenUrlSearchQueryParams.isNew]: '1'
                        }),
                        undefined,
                        false
                    )
                );
            }
        )
    );
};

const goToInternalBannersEditEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$.pipe(
        ofType(GRID_SCREEN_GO_TO_INTERNAL_BANNERS_EDIT),
        mergeMap(
            ({
                login,
                campaignsIds,
                bannersIds
            }: GoToInternalBannersEditAction): Observable<PushAction> => {
                if (!campaignsIds.length || !bannersIds.length) {
                    return EMPTY;
                }

                if (login) {
                    BannersIdsForBannersEditHelpers.setCampAndBannerIds(
                        login,
                        bannersIds
                    );

                    return of(
                        changeLocation(
                            UrlHelpers.getInternalBannersEditUrl({
                                [BannersScreenUrlSearchQueryParams.ulogin]: login,
                                [BannersScreenUrlSearchQueryParams.campaignsIds]: campaignsIds,
                                [BannersScreenUrlSearchQueryParams.bannersIds]: bannersIds
                            }),
                            undefined,
                            false
                        )
                    );
                } else {
                    throw new Error(`Не указан логин клиента`);
                }
            }
        )
    );
};

const goToInternalBannersMassEditEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
): Observable<GoToInternalBannersEditAction> => {
    return action$.pipe(
        ofType(GRID_SCREEN_GO_TO_INTERNAL_BANNERS_MASS_EDIT),
        mergeMap(() => {
            const state = store$.value;
            const { selectionInfo } = state.grid;
            const sourceParams = selectGridSourceParams(state);

            if (!sourceParams) {
                return EMPTY;
            }

            if (sourceParams && sourceParams.login) {
                return of(
                    goToInternalBannersEdit(
                        sourceParams.login,
                        selectionInfo[campaigns],
                        selectionInfo[banners]
                    )
                );
            } else {
                throw new Error(`Не указан логин клиента`);
            }
        })
    );
};

const gridScreenGoToCampaingsEditEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$.pipe(
        ofType(GRID_SCREEN_GO_TO_CAMPAIGNS_EDIT),
        switchMap(
            (action: GridScreenGoToCampaignsEditAction): Action[] => {
                const { login, campaignsIds } = action;

                if (!login) {
                    throw new Error(`Не указан логин клиента`);
                }

                CampaignsIdsForCampaignsEditHelpers.setCampaignsIds(
                    login,
                    campaignsIds
                );

                return [
                    changeLocation(
                        UrlHelpers.getCampaignsEditUrl({
                            [CampaignsScreenUrlSearchQueryParams.campaignsIds]: campaignsIds,
                            [CampaignsScreenUrlSearchQueryParams.ulogin]: login
                        }),
                        undefined,
                        false
                    )
                ];
            }
        )
    );
};

const gridScreenGoToGroupsEditEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$.ofType(GRID_SCREEN_GO_TO_GROUPS_EDIT).mergeMap(
        (action: GridScreenGoToGroupsEditAction): Observable<Action> => {
            const { login, campaignsIds, groupsIds, isNewEmptyGroup } = action;

            GroupIdsForGroupsEditHelpers.setCampAndGroupIds(
                login,
                groupsIds,
                campaignsIds
            );
            const urlQueryBaseParams = {
                [GroupsScreenUrlSearchQueryParams.campaignsIds]: campaignsIds,
                [GroupsScreenUrlSearchQueryParams.groupsIds]: groupsIds,
                [GroupsScreenUrlSearchQueryParams.ulogin]: login
            };
            let urlQueryParams = urlQueryBaseParams;

            if (action.replaceLocation) {
                urlQueryParams = {
                    ...urlQueryParams,
                    ...{ forceGroupsEditNewVisit: '1' }
                };
            }

            if (isNewEmptyGroup) {
                urlQueryParams = {
                    ...urlQueryParams,
                    ...{
                        [GroupsScreenUrlSearchQueryParams.isNewEmptyGroup]: '1'
                    }
                };
            }

            const url = UrlHelpers.getGroupsEditUrl(urlQueryParams);

            return from([
                action.replaceLocation
                    ? replaceLocation(url, undefined, false)
                    : changeLocation(url, undefined, false),
                resetGridData()
            ]);
        }
    );
};

const goToGroupsEditForCreationEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$.pipe(
        ofType(GO_TO_GROUPS_EDIT_FOR_CREATION),
        mergeMap(
            (
                action: GoToGroupsEditForCreationAction
            ): Observable<PushAction | ResetGridData> => {
                const { login, campaignId } = action;
                const groupsIds: Array<GroupId> = [];
                const campaignsIds = [campaignId];

                GroupIdsForGroupsEditHelpers.setCampAndGroupIds(
                    login,
                    groupsIds,
                    campaignsIds,
                    true
                );

                return Observable.from([
                    changeLocation(
                        UrlHelpers.getGroupsEditUrl({
                            [GroupsScreenUrlSearchQueryParams.campaignsIds]: campaignsIds,
                            [GroupsScreenUrlSearchQueryParams.groupsIds]: groupsIds,
                            [GroupsScreenUrlSearchQueryParams.ulogin]: login,
                            [GroupsScreenUrlSearchQueryParams.isNew]: '1',
                            [GroupsScreenUrlSearchQueryParams.isNewEmptyGroup]:
                                '1'
                        }),
                        undefined,
                        false
                    ),
                    resetGridData()
                ]);
            }
        )
    );
};

const goToBannersEditForCreationEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$.pipe(
        ofType(GO_TO_BANNERS_EDIT_FOR_CREATION),
        mergeMap(
            (
                action: GoToBannersEditForCreationAction
            ): Observable<PushAction | ResetGridData> => {
                const { login, campaignId, groupId } = action;
                const groupsIds: Array<GroupId> = [groupId];
                const campaignsIds = [campaignId];
                const { fromOldInterface } = store$.value.commonData;

                BannersIdsForBannersEditHelpers.setCampAndGroupIdsForCreation(
                    login,
                    campaignsIds,
                    groupsIds
                );

                return from([
                    changeLocation(
                        UrlHelpers.getBannersEditUrl({
                            [BannersScreenUrlSearchQueryParams.ulogin]: login,
                            [BannersScreenUrlSearchQueryParams.campaignsIds]: campaignsIds,
                            [BannersScreenUrlSearchQueryParams.groupsIds]: groupsIds,
                            [BannersScreenUrlSearchQueryParams.isNew]: '1',
                            from_old_interface: fromOldInterface
                                ? '1'
                                : undefined
                        }),
                        undefined,
                        false
                    ),
                    resetGridData()
                ]);
            }
        )
    );
};

const gridScreenGoToLogsEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$.ofType(GRID_SCREEN_GO_TO_LOGS).map(() => {
        const state = store$.value;
        const sourceParams = selectGridSourceParams(state);
        const { selectionInfo } = state.grid;

        if (sourceParams.login) {
            return changeLocation(UrlHelpers.getLogsUrl(), {
                cid: selectionInfo.campaigns.join(', '),
                login: sourceParams.login
            });
        } else {
            throw new Error(`Не указан логин клиента`);
        }
    });
};

const gridScreenHandleNavigationLinkClickEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$
        .ofType(GRID_SCREEN_HANDLE_NAVIGATION_LINK_CLICK)
        .map((action: GridScreenHandleNavigationLinkClickAction) => {
            const state = store$.value;
            const { selectionInfo } = state.grid;
            const sourceParams = selectGridSourceParams(state);

            const { view } = sourceParams;

            const actionsDictionary = {
                campaigns: {
                    [CampaignsAction.goToStatistics]: () =>
                        goToStatistics(action.target),
                    [CampaignsAction.goToLogs]: () => goToLogs(),
                    [CampaignsAction.goToCampaignModerationOffer]: () =>
                        goToCampaignModerationOffer(),
                    [CampaignsAction.payByCash]: () =>
                        goToDirectPaymentInstructions()
                },
                groups: {
                    [GroupsAction.goToStatistics]: () =>
                        goToStatistics(action.target),
                    [GroupsAction.editGroups]: () =>
                        goToGroupsEdit(
                            state.commonData.login,
                            selectionInfo.campaigns,
                            selectionInfo.groups
                        )
                },
                banners: {
                    [BannersAction.editBanners]: () => goToBannersMassEdit(),
                    [BannersAction.editBannersInternal]: () =>
                        goToInternalBannersMassEdit()
                },
                phrases: {},
                targeting: {}
            };

            if (
                !actionsDictionary[view] ||
                !actionsDictionary[view][action.linkAction]
            ) {
                throw new Error('Unsupported navigation link');
            }

            return actionsDictionary[view][action.linkAction]();
        });
};

const gridScreenHandleColumnsVisibilityChangeEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$
        .ofType(GRID_SCREEN_HANDLE_COLUMNS_VISIBILITY_CHANGE)
        .map((action: GridScreenHandleColumnsVisibilityChangeAction) => {
            const { columnsSettings } = store$.value.grid;
            const state = store$.value;
            const sourceParams = selectGridSourceParams(state);

            const settings = getColumnsVisibilitySettings(
                columnsSettings,
                action.columns,
                sourceParams.view
            );

            LocalStorage.setItem(StorageKeyType.columnsSettings, settings);

            return gridScreenChangeColumnsVisibility(settings);
        });
};

const gridScreenHandleColumnsOrderChangeEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$
        .ofType(GRID_SCREEN_HANDLE_COLUMNS_ORDER_CHANGE)
        .map((action: GridScreenHandleColumnsOrderChangeAction) => {
            const state = store$.value;
            const sourceParams = selectGridSourceParams(state);
            const { columnsSettings } = store$.value.grid;

            const settings = getColumnSettingsWithUpdatedOrder(
                columnsSettings,
                action.columnOrder,
                sourceParams.view
            );

            LocalStorage.setItem(StorageKeyType.columnsSettings, settings);

            return gridScreenChangeColumnsOrder(
                sourceParams.view,
                settings[sourceParams.view].columnOrder
            );
        });
};

const gridScreenHandleColumnsWidthUpdateEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$
        .ofType(GRID_SCREEN_HANDLE_COLUMNS_WIDTH_UPDATE)
        .map((action: GridScreenHandleColumnsWidthUpdateAction) => {
            const state = store$.value;
            const sourceParams = selectGridSourceParams(state);
            const { columnsSettings, isCompactViewEnabled } = store$.value.grid;

            if (action.key) {
                const settings = getColumnsWidthSettings(
                    columnsSettings,
                    action.key,
                    action.width,
                    sourceParams.view,
                    isCompactViewEnabled
                );

                LocalStorage.setItem(StorageKeyType.columnsSettings, settings);

                return gridScreenUpdateColumnsWidth(settings);
            }
            return dummyAction;
        });
};

const gridScreenHandleBulkItemsEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.ofType(GRID_SCREEN_HANDLE_BULK_ITEMS).mergeMap(
        (action: GridScreenHandleBulkItemsAction): Observable<Action> => {
            const state = store$.value;
            const sourceParams = selectGridSourceParams(state);
            const { selectionInfo, gridData } = state.grid;
            const { view: sourceParamsView, login } = sourceParams!;
            const groupsCacheKey = gridData.cacheKey;

            if (
                action.bulkAction ===
                PhrasesAction.openSearchAndReplaceInspector
            ) {
                return Observable.of(
                    switchSearchAndReplaceInspectorVisibility(true)
                );
            }

            if (action.bulkAction === GroupsAction.openMinusPhraseSelector) {
                return Observable.of(
                    openMinusPhraseSelectorGridModal(selectionInfo.groups)
                );
            }

            if (action.bulkAction === GroupsAction.openPhrasesSelectorWizard) {
                const [groupId] = selectionInfo.groups;
                const group = gridData.data.find(el => el && el.id === groupId);

                return Observable.of(
                    openPhrasesSelectorWizard(
                        PhrasesSelectorWizardId.groupsGrid,
                        group as Group
                    ),
                    fetchPhrasesForPhrasesSelectorWizard(
                        PhrasesSelectorWizardId.groupsGrid,
                        group as Group
                    )
                );
            }

            if (action.bulkAction === GroupsAction.copy) {
                return Observable.of(
                    openDuplicateGroupsModal(
                        selectionInfo.campaigns,
                        selectionInfo.groups,
                        groupsCacheKey || '',
                        login
                    )
                );
            }

            if (
                action.bulkAction ===
                    RetargetingsAction.setRetargetingCommonPriceEditor ||
                action.bulkAction ===
                    UsersProfileAction.setUsersProfileCommonPriceEditor ||
                action.bulkAction === PhrasesAction.setPhrasesCommonPriceEditor
            ) {
                return of(openCommonPriceEditor());
            }

            if (action.bulkAction === FeedFiltersAction.changeAutobudget) {
                return of(toggleFeedFilterPriorityModal());
            }

            if (action.bulkAction === FeedFiltersAction.changeRate) {
                return of(toggleFeedFilterRateModal());
            }

            let coreActionObservable: Observable<Action>;

            if (sourceParamsView === campaigns) {
                coreActionObservable = handleCampaignAction(
                    deps,
                    action.bulkAction as CampaignsAction,
                    selectionInfo.campaigns,
                    login
                );
            } else if (sourceParamsView === groups) {
                coreActionObservable = handleGroupAction(
                    deps,
                    action.bulkAction as GroupsAction,
                    selectionInfo,
                    login,
                    gridData.data as Array<GroupBaseInfo>
                );
            } else if (sourceParamsView === banners) {
                coreActionObservable = handleBannersAction(
                    deps,
                    action.bulkAction as BannersAction,
                    selectionInfo.banners,
                    login
                );
            } else if (sourceParamsView === phrases) {
                coreActionObservable = handlePhrasesAction(
                    deps,
                    action.bulkAction as PhrasesAction,
                    selectionInfo.phrases,
                    login
                );
            } else if (sourceParamsView === retargetings) {
                coreActionObservable = handleRetargetingsAction(
                    deps,
                    action.bulkAction as RetargetingsAction,
                    selectionInfo.retargetings,
                    login
                );
            } else if (sourceParamsView === feedFilters) {
                coreActionObservable = handleFeedFiltersAction(
                    deps,
                    action.bulkAction as FeedFiltersAction,
                    selectionInfo.feedFilters,
                    login
                );
            } else {
                throw new Error('Нет обработчика для массового действия');
            }

            coreActionObservable = coreActionObservable
                .mergeMap(
                    (finalAction): Observable<Action> => {
                        fireGridActionParams(action.bulkAction, {
                            campaigns: selectionInfo.campaigns.length,
                            groups: selectionInfo.groups.length,
                            phrases: selectionInfo.phrases.length,
                            retargetings: selectionInfo.retargetings.length,
                            feedFilters: selectionInfo.feedFilters.length
                        });
                        return Observable.concat(
                            Observable.of(resetGridData()),
                            Observable.of(finalAction),
                            Observable.of(updateActionProgress(false))
                        );
                    }
                )
                .catch(
                    (error): Observable<Action> => {
                        if (error instanceof NotSyncedError) {
                            return Observable.of(dummyAction);
                        }
                        if (error) {
                            const message =
                                error instanceof ApiMethodExecutingError
                                    ? error.getMessage()
                                    : error.message ||
                                      getGridActionErrorMessage(
                                          action.bulkAction,
                                          true
                                      );

                            showNoticeMessage(NoticeType.error, message);
                        }
                        return Observable.of(updateActionProgress(false));
                    }
                );

            return Observable.concat(
                Observable.of(updateActionProgress(true)),
                coreActionObservable
            );
        }
    );
};

const gridScreenHandleItemActionEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.ofType(GRID_SCREEN_HANDLE_ITEM_ACTION).mergeMap(
        (action: GridScreenHandleItemAction): Observable<Action> => {
            const state = store$.value;
            const sourceParams = selectGridSourceParams(state);
            const { gridData, selectionInfo } = store$.value.grid;
            const { view: sourceParamsView, login } = sourceParams!;
            const groupsCacheKey = gridData.cacheKey;

            let coreActionObservable: Observable<Action>;

            if (sourceParamsView === groups) {
                const group = gridData.data.find(
                    el => el && el.id === action.id
                );

                if (!group) {
                    throw new Error(`Группа с номером ${action.id} не найдена`);
                }

                if (action.action === GroupsAction.copy) {
                    return Observable.of(
                        openDuplicateGroupsModal(
                            selectionInfo.campaigns,
                            [action.id],
                            groupsCacheKey || '',
                            login
                        )
                    );
                }
                coreActionObservable = handleGroupItemAction(
                    deps,
                    action.action as GroupsAction,
                    action.id,
                    (group as Group).name,
                    login
                );
            } else if (sourceParamsView === retargetings) {
                coreActionObservable = handleRetargetingsAction(
                    deps,
                    action.action as RetargetingsAction,
                    [action.id],
                    login
                );
            } else {
                throw new Error('Нет обработчика для массового действия');
            }

            coreActionObservable = coreActionObservable
                .catch(error => {
                    if (error instanceof NotSyncedError) {
                        return Observable.of(dummyAction);
                    }

                    if (error) {
                        const message =
                            error instanceof ApiMethodExecutingError
                                ? error.getMessage()
                                : error.message ||
                                  getGridActionErrorMessage(
                                      action.action,
                                      false
                                  );

                        showNoticeMessage(NoticeType.error, message);
                    }
                    return Observable.of(dummyAction);
                })
                .mergeMap(
                    (finalAction): Observable<Action> => {
                        return Observable.concat(
                            Observable.of(resetGridData()),
                            Observable.of(finalAction),
                            Observable.of(updateActionProgress(false))
                        );
                    }
                );

            return Observable.concat(
                Observable.of(updateActionProgress(true)),
                coreActionObservable
            );
        }
    );
};

type HandleCampaignActionObservable = DummyAction | UpdateGridSelection;

const handleCampaignAction = (
    deps: EpicDeps,
    action: CampaignsAction,
    selection: GridSelection,
    login: string
): Observable<HandleCampaignActionObservable> => {
    switch (action) {
        case CampaignsAction.resume:
        case CampaignsAction.stop:
        case CampaignsAction.archive:
        case CampaignsAction.unarchive:
        case CampaignsAction.remoderate:
        case CampaignsAction.copy:
            return Observable.fromPromise(
                deps.restApiManager.executeCampaignsGridItemsAction(
                    action,
                    selection,
                    login
                )
            ).map(response => {
                let paramsNoticeMassAction;

                if (action === CampaignsAction.copy) {
                    // Так как сейчас для копирования используется перловая ручка, которая не умеет копировать, если в одной из присланных кампаний есть ошибка, то
                    // выводим общее сообщение о том, удалось копирование или нет
                    paramsNoticeMassAction = getNoticeTypeForCopyMassAction(
                        response
                    );
                } else {
                    paramsNoticeMassAction = getNoticeParamsForMassAction(
                        response,
                        selection.length
                    );
                }

                const message = getCampaignsMassActionsResultMessage(
                    action,
                    paramsNoticeMassAction.noticeType
                );

                if (message) {
                    showNoticeMessage(
                        paramsNoticeMassAction.noticeType,
                        message
                    );
                }

                return dummyAction;
            });
        case CampaignsAction.addToFavorites:
            return Observable.fromPromise(
                deps.restApiManager.addCampaignsToFavorites(selection, login)
            ).map(response => {
                const paramsNoticeMassAction = getNoticeParamsForMassAction(
                    response,
                    selection.length
                );

                const message = getCampaignsMassActionsResultMessage(
                    action,
                    getNoticeParamsForMassActionMessage(response)
                );

                if (message) {
                    showNoticeMessage(
                        paramsNoticeMassAction.noticeType,
                        message
                    );
                }

                return dummyAction;
            });
        case CampaignsAction.removeFromFavorites:
            return Observable.fromPromise(
                deps.restApiManager.removeCampaignsFromFavorites(
                    selection,
                    login
                )
            ).map(response => {
                const paramsNoticeMassAction = getNoticeParamsForMassAction(
                    response,
                    selection.length
                );

                const message = getCampaignsMassActionsResultMessage(
                    action,
                    getNoticeParamsForMassActionMessage(response)
                );

                if (message) {
                    showNoticeMessage(
                        paramsNoticeMassAction.noticeType,
                        message
                    );
                }

                return dummyAction;
            });
        case CampaignsAction.delete:
            return Observable.fromPromise(
                confirm({ message: getTextForItemActionConfirm(action) })
            ).mergeMap(() =>
                Observable.fromPromise(
                    deps.restApiManager.executeCampaignsGridItemsAction(
                        action,
                        selection,
                        login
                    )
                ).map(response => {
                    const paramsNoticeMassAction = getNoticeParamsForMassAction(
                        response,
                        selection.length
                    );

                    const message = getCampaignsMassActionsResultMessage(
                        action,
                        getNoticeParamsForMassActionMessage(response)
                    );

                    if (message) {
                        showNoticeMessage(
                            paramsNoticeMassAction.noticeType,
                            message
                        );
                    }

                    return updateSelection([]);
                })
            );
        default:
            throw new Error(
                'Нет обработчика для массового действия над кампаниями'
            );
    }
};

type HandleGroupActionObservable =
    | DummyAction
    | UpdateGridSelection
    | OpenMinusPhraseSelectorGridModal;

const handleGroupAction = (
    deps: EpicDeps,
    action: GroupsAction,
    selectionInfo: GridSelectionInfo,
    login: string,
    data: Array<GroupBaseInfo>
): Observable<HandleGroupActionObservable> => {
    const campaignId = GroupsHelpers.getFirstCampaignIdForGroups(
        selectionInfo.groups,
        data
    );

    switch (action) {
        case GroupsAction.resume:
        case GroupsAction.stop:
        case GroupsAction.archive:
        case GroupsAction.unarchive:
            return Observable.fromPromise(
                deps.restApiManager.executeGroupsGridItemsAction(
                    action,
                    selectionInfo.groups,
                    login,
                    campaignId
                )
            ).map(response => {
                const paramsNoticeMassAction = getNoticeParamsForMassAction(
                    response,
                    selectionInfo.groups.length
                );

                const message = getGroupsMassActionsResultMessage(
                    action,
                    paramsNoticeMassAction.successCount,
                    paramsNoticeMassAction.skippedCount,
                    getNoticeParamsForMassActionMessage(response)
                );

                showNoticeMessage(paramsNoticeMassAction.noticeType, message);

                return dummyAction;
            });
        case GroupsAction.remoderateBannersAdditions:
            return Observable.fromPromise(
                deps.groupsMutationExecutor.sendRemoderateAdsCallouts(
                    {
                        adGroupIds: selectionInfo.groups
                    },
                    login
                )
            ).map((result: RemoderateAdsCallouts) => {
                const {
                    remoderateAdsCallouts: {
                        processedAdGroupIds,
                        skippedAdGroupIds: { length: skippedAdGroupIdsCount }
                    }
                } = result;
                const {
                    noticeType,
                    noticeMessageType
                } = getRequestResultNoticeParams(
                    selectionInfo.groups.length,
                    processedAdGroupIds.length
                );

                const message = getGroupsMassActionsResultMessage(
                    action,
                    processedAdGroupIds.length,
                    skippedAdGroupIdsCount,
                    noticeMessageType
                );

                showNoticeMessage(noticeType, message);

                return dummyAction;
            });
        case GroupsAction.sendModerateByAgency:
        case GroupsAction.sendModerateByClient:
        case GroupsAction.admSendMD:
            return Observable.fromPromise(
                deps.restApiManager.executeDnaGroupsGridItemsAction(
                    action,
                    selectionInfo.groups,
                    login
                )
            ).map(response => {
                const paramsNoticeMassAction = getNoticeParamsForMassAction(
                    response,
                    selectionInfo.groups.length
                );

                const message = getGroupsMassActionsResultMessage(
                    action,
                    paramsNoticeMassAction.successCount,
                    paramsNoticeMassAction.skippedCount,
                    getNoticeParamsForMassActionMessage(response)
                );

                showNoticeMessage(paramsNoticeMassAction.noticeType, message);

                return dummyAction;
            });
        case GroupsAction.moderateAcceptBannersAdditions:
            return Observable.fromPromise(
                confirm({ message: getTextForItemActionConfirm(action) })
            ).mergeMap(() =>
                Observable.fromPromise(
                    deps.groupsMutationExecutor.sendRemoderateAcceptAdsCallouts(
                        {
                            adGroupIds: selectionInfo.groups
                        },
                        login
                    )
                ).map((result: RemoderateAdsCallouts) => {
                    const {
                        remoderateAdsCallouts: {
                            processedAdGroupIds,
                            skippedAdGroupIds: {
                                length: skippedAdGroupIdsCount
                            }
                        }
                    } = result;

                    const {
                        noticeType,
                        noticeMessageType
                    } = getRequestResultNoticeParams(
                        selectionInfo.groups.length,
                        processedAdGroupIds.length
                    );

                    const message = getGroupsMassActionsResultMessage(
                        action,
                        processedAdGroupIds.length,
                        skippedAdGroupIdsCount,
                        noticeMessageType
                    );

                    showNoticeMessage(noticeType, message);

                    return dummyAction;
                })
            );
        case GroupsAction.moderateAccept:
        case GroupsAction.delete:
        case GroupsAction.sendBK:
            return Observable.fromPromise(
                confirm({ message: getTextForItemActionConfirm(action) })
            ).mergeMap(() =>
                Observable.fromPromise(
                    deps.restApiManager.executeDnaGroupsGridItemsAction(
                        action,
                        selectionInfo.groups,
                        login
                    )
                ).map(response => {
                    const paramsNoticeMassAction = getNoticeParamsForMassAction(
                        response,
                        selectionInfo.groups.length
                    );

                    const message = getGroupsMassActionsResultMessage(
                        action,
                        paramsNoticeMassAction.successCount,
                        paramsNoticeMassAction.skippedCount,
                        getNoticeParamsForMassActionMessage(response)
                    );

                    showNoticeMessage(
                        paramsNoticeMassAction.noticeType,
                        message
                    );

                    return updateSelection([]);
                })
            );
        default:
            throw new Error(
                'Нет обработчика для массового действия над группами'
            );
    }
};

const handleGroupItemAction = (
    deps: EpicDeps,
    action: GroupsAction,
    id: string,
    name: string,
    login: string
): Observable<HandleGroupActionObservable> => {
    switch (action) {
        case GroupsAction.remoderateBannersAdditions:
            return Observable.fromPromise(
                deps.groupsMutationExecutor.sendRemoderateAdsCallouts(
                    {
                        adGroupIds: [id]
                    },
                    login
                )
            ).map((result: RemoderateAdsCallouts) => {
                const {
                    remoderateAdsCallouts: { processedAdGroupIds }
                } = result;

                let noticeType: NoticeType = NoticeType.success;

                if (processedAdGroupIds.length === 0) {
                    noticeType = NoticeType.error;
                }

                const message = getGroupItemActionsResultMessage(
                    action,
                    noticeType,
                    name
                );

                showNoticeMessage(noticeType, message);

                return dummyAction;
            });
        case GroupsAction.sendModerateByAgency:
        case GroupsAction.sendModerateByClient:
        case GroupsAction.admSendMD:
            return Observable.fromPromise(
                deps.restApiManager.executeDnaGroupsGridItemsAction(
                    action,
                    [id],
                    login
                )
            ).map(response => {
                const paramsNoticeMassAction = getNoticeParamsForMassAction(
                    response,
                    1
                );

                const message = getGroupItemActionsResultMessage(
                    action,
                    paramsNoticeMassAction.noticeType,
                    name
                );

                showNoticeMessage(paramsNoticeMassAction.noticeType, message);

                return dummyAction;
            });
        case GroupsAction.moderateAcceptBannersAdditions:
            return Observable.fromPromise(
                confirm({ message: getTextForItemActionConfirm(action) })
            ).mergeMap(() =>
                Observable.fromPromise(
                    deps.groupsMutationExecutor.sendRemoderateAcceptAdsCallouts(
                        {
                            adGroupIds: [id]
                        },
                        login
                    )
                ).map((result: RemoderateAdsCallouts) => {
                    const {
                        remoderateAdsCallouts: { processedAdGroupIds }
                    } = result;

                    let noticeType: NoticeType = NoticeType.success;

                    if (processedAdGroupIds.length === 0) {
                        noticeType = NoticeType.error;
                    }

                    const message = getGroupItemActionsResultMessage(
                        action,
                        noticeType,
                        name
                    );

                    showNoticeMessage(noticeType, message);

                    return dummyAction;
                })
            );
        case GroupsAction.moderateAccept:
        case GroupsAction.delete:
        case GroupsAction.sendBK:
            return Observable.fromPromise(
                confirm({
                    message: getTextForRowItemActionConfirm(action, name)
                })
            ).mergeMap(() =>
                Observable.fromPromise(
                    deps.restApiManager.executeDnaGroupsGridItemsAction(
                        action,
                        [id],
                        login
                    )
                ).map(response => {
                    const paramsNoticeMassAction = getNoticeParamsForMassAction(
                        response,
                        1
                    );

                    const message = getGroupItemActionsResultMessage(
                        action,
                        paramsNoticeMassAction.noticeType,
                        name
                    );

                    showNoticeMessage(
                        paramsNoticeMassAction.noticeType,
                        message
                    );

                    return updateSelection([]);
                })
            );
        default:
            throw new Error(
                'Нет обработчика для массового действия над группами'
            );
    }
};

type HandleBannersActionObservable = DummyAction | UpdateGridSelection;

const handleBannersAction = (
    deps: EpicDeps,
    action: BannersAction,
    selection: GridSelection,
    login: string
): Observable<HandleBannersActionObservable> => {
    const massBannerActionHandler = () =>
        Observable.fromPromise(
            deps.bannersMutationExecutor
                .runMassAction(
                    {
                        adIds: selection
                    },
                    login,
                    action
                )
                .then(response => ({
                    updated_objects: response.processedAdIds,
                    skipped_objects: response.skippedAdIds
                }))
        ).map(response => {
            const paramsNoticeMassAction = getNoticeParamsForMassAction(
                response,
                selection.length
            );

            const message = getBannersMassActionsResultMessage(
                action,
                paramsNoticeMassAction.successCount,
                paramsNoticeMassAction.skippedCount,
                getNoticeParamsForMassActionMessage(response)
            );

            showNoticeMessage(paramsNoticeMassAction.noticeType, message);

            return dummyAction;
        });

    switch (action) {
        case BannersAction.delete:
            return Observable.fromPromise(
                confirm({ message: getTextForItemActionConfirm(action) })
            )
                .mergeMap(massBannerActionHandler)
                .map(() => {
                    return updateSelection([]);
                });
        case BannersAction.stop:
        case BannersAction.resume:
        case BannersAction.archive:
        case BannersAction.unarchive:
            return massBannerActionHandler();
        default:
            throw new Error(
                'Нет обработчика для массового действия над группами'
            );
    }
};

type HandlePhrasesActionObservable =
    | DummyAction
    | UpdateGridSelection
    | OpenPricesWizard;

const handlePhrasesAction = (
    deps: EpicDeps,
    action: PhrasesAction,
    keywordIds: string[],
    login: string
): Observable<HandlePhrasesActionObservable> => {
    let observable: Observable<HandlePhrasesActionObservable>;

    switch (action) {
        case PhrasesAction.delete:
            observable = Observable.fromPromise(
                confirm({
                    message: getTextForItemActionConfirm(action)
                })
            )
                .map(() =>
                    Observable.fromPromise(
                        deps.phrasesMutationExecutor.deleteKeywords(
                            {
                                keywordIds
                            },
                            login
                        )
                    )
                )
                .map(() => updateSelection([]));
            break;
        case PhrasesAction.enable:
            observable = Observable.fromPromise(
                deps.phrasesMutationExecutor.unsuspendKeywords(
                    {
                        keywordIds
                    },
                    login
                )
            ).map(() => dummyAction);
            break;
        case PhrasesAction.disable:
            observable = Observable.fromPromise(
                deps.phrasesMutationExecutor.suspendKeywords(
                    {
                        keywordIds
                    },
                    login
                )
            ).map(() => dummyAction);
            break;
        case PhrasesAction.pricesWizard:
            observable = Observable.of(openPricesWizard());
            break;
        default:
            throw new Error(
                'Нет обработчика для массового действия над фразами'
            );
    }

    return observable.do(() =>
        showNoticeMessage(
            NoticeType.success,
            getPhrasesMassActionsResultMessage(action)
        )
    );
};

type HandleRetargetingsActionObservable = DummyAction;

const handleRetargetingsAction = (
    deps: EpicDeps,
    action: RetargetingsAction,
    retargetingIds: string[],
    login: string
): Observable<HandleRetargetingsActionObservable> => {
    switch (action) {
        case RetargetingsAction.resume:
            return from(
                deps.retargetingMutationExecutor.resumeRetargetings(
                    retargetingIds,
                    login
                )
            ).pipe(
                mergeMap(response => {
                    const { data } = response;

                    if (!data) {
                        throw new Error();
                    }

                    const {
                        successCount,
                        totalCount
                    } = data.resumeRetargetings;

                    showRetargetingActionNoticeMessage(
                        action,
                        successCount,
                        totalCount
                    );
                    return of(dummyAction);
                })
            );
        case RetargetingsAction.suspend:
            return from(
                deps.retargetingMutationExecutor.suspendRetargetings(
                    retargetingIds,
                    login
                )
            ).pipe(
                mergeMap(response => {
                    const { data } = response;

                    if (!data) {
                        throw new Error();
                    }

                    const {
                        successCount,
                        totalCount
                    } = data.suspendRetargetings;

                    showRetargetingActionNoticeMessage(
                        action,
                        successCount,
                        totalCount
                    );
                    return of(dummyAction);
                })
            );
        case RetargetingsAction.delete:
            return from(
                confirm({
                    message: getTextForItemActionConfirm(
                        RetargetingsAction.delete
                    )
                })
            ).pipe(
                mergeMap(() =>
                    from(
                        deps.retargetingMutationExecutor.deleteRetargetings(
                            retargetingIds,
                            login
                        )
                    ).pipe(
                        mergeMap(response => {
                            const { data } = response;

                            if (!data) {
                                throw new Error();
                            }

                            const {
                                successCount,
                                totalCount
                            } = data.deleteRetargetings;

                            showRetargetingActionNoticeMessage(
                                action,
                                successCount,
                                totalCount
                            );
                            return of(dummyAction);
                        })
                    )
                )
            );
        default:
            throw new Error(
                'Нет обработчика для массового действия над условиями ретаргетинга'
            );
    }
};

const handleFeedFiltersAction = (
    deps: EpicDeps,
    action: FeedFiltersAction,
    filterIds: string[],
    login: string
): Observable<Action> => {
    switch (action) {
        case FeedFiltersAction.changeRate:
            return of(toggleFeedFilterRateModal());
        case FeedFiltersAction.changeAutobudget:
            return of(toggleFeedFilterPriorityModal());
        case FeedFiltersAction.disable:
            return disableFeedFilters(deps, filterIds, login);
        case FeedFiltersAction.enable:
            return enableFeedFilters(deps, filterIds, login);
        case FeedFiltersAction.delete:
            return deleteFeedFilters(deps, filterIds, login);
        default:
            throw new Error(
                'Нет обработчика для массового действия над фильтрами фидов'
            );
    }
};

export const gridScreenHelpersEpic = combineEpics(
    gridScreenCancelCellEditEpic,
    gridScreenGoToStatisticsEpic,
    gridScreenGoToCampaingsEditEpic,
    gridScreenGoToCampaignModerationOfferEpic,
    gridScreenGoToBannersEditEpic,
    gridScreenGoToBannersMassEditEpic,
    gridScreenGoToGroupsEditEpic,
    gridScreenGoToLogsEpic,
    gridScreenHandleNavigationLinkClickEpic,
    gridScreenHandleColumnsVisibilityChangeEpic,
    gridScreenHandleColumnsOrderChangeEpic,
    gridScreenHandleColumnsWidthUpdateEpic,
    gridScreenHandleBulkItemsEpic,
    goToGroupsEditForCreationEpic,
    goToBannersEditForCreationEpic,
    goToInternalBannersEditForCreationEpic,
    goToInternalBannersEditEpic,
    goToInternalBannersMassEditEpic,
    gridScreenGoToDirectPaymentInstructions,
    gridScreenHandleItemActionEpic
);
